export default __webpack_public_path__ + "static/media/marine-tab-icon.19af2a79.svg";